import React, { Fragment, useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Global } from "../../../Global";
import uploadFile from "../../../images/uploadFile.jpg";
import axios from "axios";
import { useSelector } from "react-redux";

const AllowedItemManage = () => {
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [allowedItemName, setAllowedItemName] = useState("");
  const [allowedItemIcon, setAllowedItemIcon] = useState("");
  const [allowedItemImage, setAllowedItemImage] = useState("");
  const [isPublished, setIsPublished] = useState(true);
  const { userToken, userId } = useSelector((state) => state.credential);

  const { id, allowedItemId } = useParams();
  const navigate = useNavigate();

  const validForm =
    allowedItemName.trim() !== "" && allowedItemIcon.trim() !== "";
  const Submit = async (e) => {
    e.preventDefault();
    if (!validForm) {
      toast.error("Fill all the  fields");
    } else {
      if (parseInt(allowedItemId) === 0) {
        try {
          const response = await fetch(
            Global.API_URL + "RoomAllowedItem/AddRoomAllowedItems",
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "bs-api-key": Global.bs_api_key,
                AuthorizationUser: userToken,
              },
              body: JSON.stringify({
                roomAllowedItemName: allowedItemName,
                roomAllowedItemIcon: allowedItemIcon,
                roomAllowedItemImage: allowedItemImage,
                isPublished: isPublished,
              }),
            }
          );
          if (response.ok) {
            const result = await response.json();
            if (result.code === 0) {
              toast.success(result.message);
              navigate("/room-allowed-item");
            } else {
              toast.error(result.message);
            }
          } else {
            const result = await response.json();
            toast.error(result.message);
          }
        } catch (error) {
          toast.error(error.Message || "Something went wrong");
        }
      } else {
        try {
          const response = await fetch(
            Global.API_URL +
              "RoomAllowedItem/EditAllowedItem?itemid=" +
              allowedItemId,
            {
              method: "PUT",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "bs-api-key": Global.bs_api_key,
                AuthorizationUser: userToken,
              },
              body: JSON.stringify({
                roomAllowedItemName: allowedItemName,
                roomAllowedItemIcon: allowedItemIcon,
                roomAllowedItemImage: allowedItemImage,
                isPublished: isPublished,
              }),
            }
          );
          if (response.ok) {
            const result = await response.json();
            if (result.code === 0) {
              toast.success(result.message);
              navigate("/room-allowed-item");
            } else {
              toast.error(result.message);
            }
          } else {
            const result = await response.json();
            toast.error(result.message);
          }
        } catch (error) {
          toast.error(error.Message || "Something went wrong");
        }
      }
    }
    setDisableSubmit(false);
  };

  const handleIcon = async (e) => {
    const formData = new FormData();
    formData.append("Images", e.target.files[0]);
    formData.append("Sender", "A");
    formData.append("SenderID", userId);

    try {
      const response = await axios.post(
        Global.API_URL + "Others/UploadSingleImage",
        formData,
        {
          headers: {
            "bs-api-key": Global.bs_api_key,
            AuthorizationUser: userToken,
          },
        }
      );
      setAllowedItemIcon(response.data[0]);
    } catch (ex) {
      console.log(ex);
    }
  };

  const handleImage = async (e) => {
    const formData = new FormData();
    formData.append("Images", e.target.files[0]);
    formData.append("Sender", "A");
    formData.append("SenderID", userId);

    try {
      const response = await axios.post(
        Global.API_URL + "Others/UploadSingleImage",
        formData,
        {
          headers: {
            "bs-api-key": Global.bs_api_key,
            AuthorizationUser: userToken,
          },
        }
      );
      setAllowedItemImage(response.data[0]);
    } catch (ex) {
      console.log(ex);
    }
  };

  useEffect(() => {
    if (parseInt(allowedItemId) !== 0) {
      const GetAllowedItem = async () => {
        try {
          const response = await fetch(
            Global.API_URL +
              "RoomAllowedItem/GetRoomAllowedItemById?roomitemid=" +
              allowedItemId,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "bs-api-key": Global.bs_api_key,
              },
            }
          );
          if (response.ok) {
            const result = await response.json();
            if (result.code === 0) {
              setAllowedItemName(result.message.itemName);
              setAllowedItemIcon(result.message.itemIcon);
              setAllowedItemImage(result.message.itemImage);
              setIsPublished(result.message.isPublished);
            } else {
              toast.error(result.message);
            }
          } else {
            const result = await response.json();
            toast.error(result.message);
            navigate("/room-allowed-item");
          }
        } catch (error) {
          toast.error(error.Message || "Something went wrong");
          navigate("/room-allowed-item");
        }
      };

      GetAllowedItem();
    }
  }, [allowedItemId, navigate, id]);

  return (
    <Fragment>
      <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
        <div className="card-action coin-tabs mb-2"></div>
        <div className="d-flex align-items-center mb-2">
          <button
            type="submit"
            className="btn btn-primary margin-right-15"
            onClick={(e) => Submit(e)}
            disabled={disableSubmit}
          >
            Submit
          </button>
          <Link
            to={"/room-allowed-item"}
            className="btn btn-secondary"
          >
            Back
          </Link>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="form-group mb-5 col-md-6 col-lg-6 ">
                  <label>
                    Item Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Item Name"
                    value={allowedItemName}
                    onChange={(e) => setAllowedItemName(e.target.value)}
                  />
                </div>
                <div className="form-group mb-5 col-md-6 col-lg-6 ">
                  <div className="form-check form-check-inline mt-6">
                    <label className="form-check-label">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        value={isPublished}
                        checked={isPublished}
                        onChange={(e) =>
                          setIsPublished(
                            e.target.value === "true" ? false : true
                          )
                        }
                      />
                      Published
                    </label>
                  </div>
                </div>
              </div>

              <div className="row">
              <div className="form-group mb-5 col-md-6 col-lg-6 ">
                  <label>
                    Allowed Item Image <span className="text-danger">*</span>
                  </label>
                  <br />
                  <label htmlFor="allowedItemImage">
                    <img
                      src={
                        allowedItemImage && allowedItemImage !== ""
                          ? Global.PHOTO_URL + allowedItemImage
                          : uploadFile
                      }
                      width="250"
                      alt="allowedItemImage"
                    />
                  </label>
                  <input
                    type="file"
                    name="allowedItemImage"
                    id="allowedItemImage"
                    onChange={handleImage}
                    style={{ visibility: "hidden" }}
                  ></input>
                </div>

                <div className="form-group mb-5 col-md-6 col-lg-6 ">
                  <label>
                    Allowed Item Icon <span className="text-danger">*</span>
                  </label>
                  <br />
                  <label htmlFor="allowedItemIcon">
                    <img
                      src={
                        allowedItemIcon === ""
                          ? uploadFile
                          : Global.PHOTO_URL + allowedItemIcon
                      }
                      width="250"
                      alt="allowedItemIcon"
                    />
                  </label>
                  <input
                    type="file"
                    name="allowedItemIcon"
                    id="allowedItemIcon"
                    onChange={handleIcon}
                    style={{ visibility: "hidden" }}
                  ></input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AllowedItemManage;
